import { gql } from '@apollo/client';

export const removeProductFromSaveForLaterMutation = gql`
  mutation RemoveProductFromSaveForLater($sku: String!, $locale: Locale!) {
    data: removeArticleFromSavedForLater(sku: $sku) {
      articles(locale: $locale) {
        sku
      }
    }
  }
`;
